import {
  BIZ_CLASS,
  NO_CONTRACT, NO_DRM_SUPPORT,
  NO_VOD_COUNTRY,
  NOT_ENABLED_IN_COUNTRY, PARTNER_IS_DISABLED,
} from './constants';
import { ERROR_TYPE } from '../containers/ErrorPage/errorTypes';

export default new Map([
  [NO_VOD_COUNTRY, ERROR_TYPE.GEO],
  [NOT_ENABLED_IN_COUNTRY, ERROR_TYPE.GEO],
  [PARTNER_IS_DISABLED, ERROR_TYPE.LICENSE],
  [NO_CONTRACT, ERROR_TYPE.LICENSE],
  [BIZ_CLASS, ERROR_TYPE.LICENSE],
  [NO_DRM_SUPPORT, ERROR_TYPE.DRM],
]);
